/* effect.js — safe injector & effects for CrazyResell */
/* Adds .fx to body, injects background node, shows intro, observes .fx-fade */

(function(){
  function safeLog(){ try{ console.log.apply(console, arguments); }catch(e){} }

  document.addEventListener('DOMContentLoaded', function() {
    try {
      // 1) Add .fx to body (scoped styling)
      var body = document.body || document.getElementsByTagName('body')[0];
      if (!body) return;
      if (!body.classList.contains('fx')) body.classList.add('fx');

      // 2) Ensure there is a bg node (non-invasive)
      if (!document.querySelector('.fx-bg')) {
        var bg = document.createElement('div');
        bg.className = 'fx-bg';
        // append to html so z-index stays behind everything
        var html = document.documentElement || document.getElementsByTagName('html')[0];
        if (html) html.appendChild(bg);
      }

      // 4) IntersectionObserver for .fx-fade => add .fx-inview
      try {
        var fadeEls = document.querySelectorAll('.fx-fade');
        if (fadeEls.length) {
          var io = new IntersectionObserver(function(entries){
            entries.forEach(function(entry){
              if (entry.isIntersecting) {
                entry.target.classList.add('fx-inview');
                io.unobserve(entry.target);
              }
            });
          }, { root: null, rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
          fadeEls.forEach(function(el){ io.observe(el); });
        }
      } catch(e) { safeLog('fx observer failed', e); }

      // 5) Button active state (press/hold)
      document.addEventListener('pointerdown', function(e){
        var b = e.target.closest('.fx-btn, button, a.button, .btn');
        if (b) b.classList.add('active');
      });
      document.addEventListener('pointerup', function(e){
        var b = e.target.closest('.fx-btn, button, a.button, .btn');
        if (b) setTimeout(function(){ b.classList.remove('active'); }, 80);
      });

      safeLog('fx: initialized');
    } catch(err) {
      safeLog('fx init error', err);
    }
  });
})();